import * as React from "react";
const SvgClose20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 13,
        height: 12,
        fill: "black",
        viewBox: "0 0 13 12"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m2 .086 4.5 4.5 4.5-4.5L12.414 1.5 7.914 6l4.5 4.5L11 11.914l-4.5-4.5-4.5 4.5L.586 10.5l4.5-4.5-4.5-4.5L2 .086Z",
      clipRule: "evenodd"
    })
  );
export default SvgClose20Px;
